import { Link } from "react-router-dom";

export const Logo = ({ variant = "dark", className = "" }) => {
  const src = variant === "dark" ? "/logo.png" : "/logo-mark-light.png";
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`inline-flex items-center ${className}`}
      aria-label="Biz360 Compliance home"
    >
      <img src={src} alt="Biz360 Compliance" className="h-9 w-auto sm:h-10 md:h-12 object-contain" />
    </Link>
  );
};
